import React from 'react';
import './About.css';
import { motion } from 'framer-motion';
import mobilecold from '../assets/images/apple.jpg'; // Replace with your image path
import aboutbg from '../assets/images/aboutsection.jpg'
import ProjectCarousel3 from './projectcrousel3'; // Import the new component
const AboutUs = () => {
  const activities = [
    'Manufacturing',
    'Turnkey Project Execution',
    'Product & Project Designing',
    'Product Development',
    'Project Management',
    'Technical Consulting',
    'After Sales Service',
    'Renovation & Up gradation of Existing Cold Storages'   

  ];

  const coldsolutions = [
    'Manufacturing',
    'Cold Rooms',
    'Freezer Rooms',
    'Low RH Cold Storages',
    'TICT (Thermal Inverter Cooling Technology) Based Cold Rooms & Cold storages – Innovative Cold Chain Solution',
    'Dehumidification & Process Hall Air Conditioning',
    'Walk in Chillers & Freezers',
    'Large Cold Storages',
    'Multi Chamber & Multi Commodity Cold Storages',
    'High Humidity Cold Storages',
    'Temperature & Humidity Controlled Warehousing',
    'Farm Level Mini Cold Storage',
    'Pack House',
    'Pre coolers',
    'Ripening Chambers',
    'Process Hall & Packaging Area',
    'Mobile Cold Rooms',
    'Blast Chillers',
    'Freezer Rooms',
    'Frozen Food Cold Storages',
    'Blast Freezers',
    'Hardening Tunnels',
    'Seed Storage Cold Storages',
    'Blood Banks',
    'Display Type Cold Rooms for Retail Segment',
      ];

  const mobilesolution =[
    'Insulated Truck & Delivery Vans with Thermal Inverter Cooling Technique',
    'Refrigerated Trucks & Vans',
    'Trucks Refrigeration Units',
    'Insulated Trucks Bodies',
    'Insulated & ventilated Trucks & Trailers'
  ]; 
  const othersolution = [
    'Insulated Boxes',
    'Insulated  & refrigerated Boxes with TICT',
    'Prefabricated Construction through Modular Sandwich Panels.',
    'Roof Insulation',
    'Partition Walls',
    'False Ceiling',
    'Flooring Solutions',
    'Cold Rooms and Cold Storage Doors',
    'Industrial Doors',
    'Grading and Sorting Lines',
    'Refrigeration Systems',
    'HVAC Solution',
      ];
  return (
    <div className="about-us-container">
      <motion.div 
        className="about-us-hero"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ backgroundImage: `url(${aboutbg})` }}
      >
        <h1 className="about-us-title">About Jaikon</h1>
      </motion.div>
      

      <div className="about-us-content">
        <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2>Innovative & Integrated Cold Chain Solutions Provider</h2>
          <p>
          Jaikon Refrigeration India Private Limited ( A Jaikon Group Company) is an innovation driven Company offers Turnkey Solutions in the field of Commercial & Industrial Refrigeration, Cold Chain Solution , Post-Harvest Management Techniques & Green Energy Solutions  like Solar ,Wind and Geothermal.
          </p>
          <p>
          We are manufactures of Cold Rooms, Cold Storages, Refrigeration Units and other Commercial & Industrial Cooling Products
          </p>
          <p>
          Jaikon offers Turnkey Projects solution Including Manufacturing, Planning, Designing, Project Management Consulting and System Integration for Setting up Cold Chain Solutions consisting of  Cold Rooms, Cold Storages, CA Chambers, Ripening Chambers, Frozen Food Chambers, Precoolers, IQF and Multi Chamber Cold Chain Sets .
          </p>
          <p>
          Jaikon has successfully developed and Commercialize Innovative Solutions like Thermal Inverter Technology Cold Chain, Low Cost Farm Level Cold Chain and working on several new Innovation driven projects in the field of “Green Cold Chain Solutions “.
          </p>
          <p>
          Jaikon Corporate office & Manufacturing Facility is in Noida, (Delhi NCR) & Registered Office in Roorkee, Uttarakhand. The Company has established a strong Network and associates across India and neighbouring countries like Bangladesh, Sri Lanka & Nepal.
          </p>
        </motion.div>

        <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          
          <div>
      <h3>Our Actives Included</h3>
      <ul>
        {activities.map((activity, index) => (
          <li key={index}>{activity}</li>
        ))}
      </ul>
    </div>    
     </motion.div>

     <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
          style={{ backgroundImage: `url(${mobilecold})` }}
        >
          
          <div className="about-us-content">
          <h2>Some of the Key Solutions we offer are:</h2>
          <h3>A) Cold Room & Cold Storages</h3>

      <ul>
        {coldsolutions.map((activity, index) => (
          <li key={index}>{activity}</li>
        ))}
      </ul>
    </div>    
     </motion.div>

    
     <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          
      <div className="about-us-content">
          
          <h3>B ) Mobile Cold Chain Solutions:</h3>
      <ul>
        {mobilesolution.map((activity, index) => (
          <li key={index}>{activity}</li>
        ))}
      </ul>
    </div>    
    </motion.div>
     <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          
      <div className="about-us-content">

          <h3>C) Other Solutions:</h3>
      <ul>
        {othersolution.map((activity, index) => (
          <li key={index}>{activity}</li>
        ))}
      </ul>
      
    </div>   
    <h3>D ) Refrigeration Equipment’s & Products: </h3>
     </motion.div>



     

        <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <p>
            Jaikon has successfully developed and commercialized innovative solutions like Thermal Inverter Technology Cold Chain, Low-Cost Farm Level Cold Chain, and is working on several new innovation-driven projects in the field of “Green Cold Chain Solutions.”
          </p>
        </motion.div>

        <motion.div 
          className="about-us-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.9 }}
          viewport={{ once: true }}
        >
          <p>

          </p>
        </motion.div>

        <section className="project-section">
            <div className="project-content">
                <div className="project-description" style={{ backgroundColor: 'white' }}>
                    <h2>News & Updates</h2>
                    <p>Description of project 1 with relevant details.</p>
                </div>
                <div className="project-images">
                    <ProjectCarousel3 />
                </div>
            </div>
        </section>

      </div>

      </div>
  
  );
};

export default AboutUs;
  